
export default {
  props: ['title'],
  data: function data() {
    return {};
  },

  computed: {
    innerTitle: function innerTitle() {
      return this.title || '分类标题';
    }
  },
  methods: {
    handleCreate: function handleCreate() {
      this.$emit('create');
    }
  }
};